import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

import reducers from "./reducers";
import sagas from "./sagas";
import { middleware as routerMiddleware } from "./router";

import { restaureAuthData } from "../pages/utils/auth/authData";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  reducers,
  composeWithDevTools({})(
    applyMiddleware(thunk, sagaMiddleware, routerMiddleware)
  )
);

sagaMiddleware.run(sagas);

restaureAuthData(store);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js